export default "__VITE_ASSET__CkFPf07G__"